import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { Field } from 'formik'

interface Props {}

export const DemolitionTechnicalFormB1A: React.FC<Props> = (props) => {
  return (
    <FormSectionTwoColumns
      title="a) druh a účel užívání odstraňované stavby, charakteristika území, ve kterém se odstraňovaná stavba nachází"
      subtitle="včetně charakteristiky zastavěného stavebního pozemku"
      sectionKey="b1a"
    >
      <>
        <div className="sm:col-span-6">
          <Field
            name="b1a.typeOfConstruction"
            label="Druh odstraňované stavby"
            component={RichTextInput}
            aiHint={
              'Druh odstraňované stavby'
            }
          />
        </div>
      </>
    </FormSectionTwoColumns>
  )
}
